const cacheBust = () => {
  const url = new URL(window.location.href)

  if (!url.searchParams.has('cacheBust')) {
    url.searchParams.set('cacheBust', new Date().getTime()); // Add or update the cacheBust parameter
    window.location.href = url.toString(); // Redirect to the updated URL
  }
}

export default cacheBust